// src/components/AuthGuard.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./UserContext";

const AuthGuard = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    // Redirect to the login page if not logged in
    return <Navigate to="/login" />;
  }

  // Render the children (protected content) if logged in
  return children;
};

export default AuthGuard;
